import * as React from "react";
import { forwardRef } from "react";
const SvgIconStarOutline = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 38, viewBox: "0 0 40 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.7 29.65L20 25.85L26.3 29.7L24.65 22.5L30.2 17.7L22.9 17.05L20 10.25L17.1 17L9.8 17.65L15.35 22.5L13.7 29.65ZM7.65 38L10.9 23.95L0 14.5L14.4 13.25L20 0L25.6 13.25L40 14.5L29.1 23.95L32.35 38L20 30.55L7.65 38Z", fill: "#525A5C" }));
const ForwardRef = forwardRef(SvgIconStarOutline);
export default ForwardRef;
